import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: '24"', label: '24"' },
  { value: '30"', label: '30"' },
  { value: '32"', label: '32"' },
  { value: '34"', label: '34"' },
  { value: '36"', label: '36"' },
  { value: '40"', label: '40"' },
  { value: '42"', label: '42"' },
];

const DEFAULT = '32"';

const DoorSize = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdDoorSize">Door Size</label>
      <select id="SdDoorSize" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DoorSize;
